<template>
  <div class="app">
    <iframe id="iframe" class="iframe" src="mms3D/index1.html" frameborder="0"></iframe>
    <iframe id="iframe2" class="iframe2" :src="ifsrc" v-show="ifshow"></iframe>
    <div class="close" @click="close" v-show="ifshow">退出</div>
    <!-- 风险框 -->
    <div class="risk" :id="'risk'+i" v-for="i in 1" :key="'rs'+i" v-show="riskt" :style="bg">
      <div class="subject">
        <!-- title -->
        <div class="title">
          {{ titlename }}
          <span style="margin-right:15px" @click="lsjl('risk'+i,i)">历史记录</span>
          <span @click="risktt('risk'+i,i)">X</span>
        </div>
        <!-- neix -->
        <div class="risk-n">
          <i class="icon"></i>
          <span>风险类型:</span>
          {{ rish }}
        </div>
        <!-- text -->
        <div class="text">
          <div class="text-now">
            <i class="icon"></i>
            <span>详情:</span>
          </div>
          <div class="text-sui">{{content}}</div>
        </div>
        <!-- neix -->
        <div class="location">
          <i class="icon"></i>
          <span>风险位置实时检测数据 2021-12-21 10:45:19</span>
        </div>
        <!-- 各项数据 -->
        <div class="information">
          <div
            class="information-boer"
            v-for="(item, index) in mashgas"
            :key="index"
          >{{ item.name }}: {{ item.nuber }}</div>
        </div>
        <!-- 风险位置 -->
        <div class="location">
          <i class="icon"></i>
          <span>风险位置人员情况</span>
        </div>
        <!-- 风险区域 -->
        <div class="risk-area">
          <span>风险区域内:</span>
          <div class="risk-depend">
            <div></div>
          </div>
          <span>5人</span>
        </div>
        <!-- 风险区域附件 -->
        <div class="risk-area">
          <span>风险区域附近:</span>
          <div class="risk-depend">
            <div></div>
          </div>
          <span>5人</span>
        </div>
        <!-- 风险监控 -->
        <div class="sxt">
          <div class="sxt-title">
            <i class="icon"></i>
            <span>风险点附近视频监控</span>
          </div>
          <!-- sxt -->
          <div class="sxt-video">
            <div class="sxt-videow" v-for="item in 2" :key="item">
              <span>视频</span> 
              <hr />
              <div>
                <video
                  style="width:100%;height:100%;object-fit: fill;"
                  src="./assets/sp2.mp4"
                  muted
                  autoplay
                  loop
                ></video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 聚合框 -->
    <div
      class="all"
      v-for="(item, index) in jhpop"
      :key="index"
      :id="item.id"
      v-show="control&&index == 0"
    >
      <div class="all-item">
        <div class="item1" v-for="(item2, index2) in item" :key="'t'+index2">
          <div class="item1-child">{{item2.devName}}</div>
          <div
            class="item1-child"
            v-for="(item3,index3) in item2.data"
            :key="'c'+index3"
          >{{item3.value}}</div>
        </div>
      </div>
    </div>
    <div class="videobox" v-for="(item,i) in videodata" :key="'sp'+i" :id="item.code">
      <div class="videohead">
        <div class="videotitle">{{item.devName}}</div>
        <div class="videoclose" @click="closesp(item.code)">X</div>
      </div>
      <div class="myvideo">
        <video
          :id="'vid'+i"
          style="width:100%;height:100%;object-fit: fill;"
          :src="item.videoUrl"
          muted
          loop
        ></video>
      </div>
    </div>
    <!-- 3D复用框 -->
    <!--<div class="f3D" v-show="control" id="f3D">
      <div class="f3D-title">
        {{ title }}
        <span @click="control = false">×</span>
      </div>
      <div class="f3d-suyle">
        <i></i>
        <span style="color: rgb(185, 216, 255)">状态:</span>
        <span style="color: rgb(102, 210, 252)">在线</span> 正常
      </div>
      <div class="f3d-suyle" v-for="(e, i) in list" :key="i">
        <i></i>
        <span style="color: rgb(185, 216, 255)">{{ e.name }}</span>
        {{ e.props }}
      </div>
      <div class="buttom">检测历史数据</div>
    </div>-->
    <!-- 实时值框 -->
    <div
      :class="item.data.length==1?'truetiem':'truetiemtwo'"
      :id="item.code"
      v-for="(item, index) in beselist"
      v-show="price"
    >
      <div v-for="(item2,index) in item.data">{{item2.key}}{{item2.value}}</div>
    </div>
    <div class="title-left" v-for="(item,i) in title.left" :id="item.id" :key="item.id">
      <div class="content">{{item.name}}</div>
    </div>
    <div class="title-right" v-for="(item,i) in title.right" :id="item.id" :key="item.id">
      <div class="content">{{item.name}}</div>
    </div>
      <div class="playover" @click="playover()" v-show="nowpage == 0">
      <img src="./assets/bfjs.png" style="margin-right:9px"/>
      <div>播放结束</div>
    </div>
    <router-view />
  </div>
</template>
<script>
import { beseGet, viderGet } from "./api/api.js";
import { connect } from "./api/scoket";
import { connect2 } from "./api/scoket2";
import { connect3 } from "./api/scoket3";
import { connect4 } from "./api/scoket4";
import { connect5 } from "./api/scoket5";
import { decode64 } from "./api/base64";
export default {
  data() {
    return {
      // 风险框 的变量
      titlename: "瓦斯",
      rish: "瓦斯爆炸",
      content:
        " 2021年12月13日中班，分析1207工作面回风巷为瓦斯爆炸高风险区。按照***制度，应及时 采取措施",
      mashgas: [
        {
          name: "瓦斯浓度",
          nuber: 12.5
        },
        {
          name: "粉尘浓度",
          nuber: 12.5
        },
        {
          name: "风速",
          nuber: 12.5
        },
        {
          name: "分量",
          nuber: 12.5
        },
        {
          name: "CO浓度",
          nuber: 12.5
        },
        {
          name: "湿度",
          nuber: 12.5
        }
      ],
      riskt: false,
      // 聚合框
      list1: [
        { name: "温度实时数据:", nuber: 158.8 },
        { name: "风速实时数据:", nuber: 158.8 },
        { name: "瓦斯实时数据:", nuber: 158.8 },
        { name: "粉尘实时数据:", nuber: 158.8 },
        { name: "CO实时数据:", nuber: 158.8 }
      ],
      jhdata: [],
      jhpop: [],
      // 3D复用
      title: "",
      control: false,
      list: [
        { name: "位置:", props: "主运100米" },
        { name: "事件:", props: "2021-10-1 10:45:19" },
        { name: "CO浓度实时值:", props: "2.35" }
      ],
      // 请求的设备json
      beselist: [],
      beselist1: [],
      // 实时值框
      price: false,
      title: {
        left: [
          { name: "截割头", id: "jjj1" },
          { name: "星轮", id: "jjj2" },
          { name: "铲板", id: "jjj3" },
          { name: "滚筒", id: "cm1" }
        ],
        right: [
          { name: "截割臂/摆臂", id: "jjj4" },
          { name: "履带", id: "jjj5" },
          { name: "后支撑", id: "jjj6" },
          { name: "滚筒", id: "cm2" }
        ]
      },
      ifsrc: "",
      ifshow: false,
      videodata: [],
      timer: [],
      bg:{backgroundImage:"url("+require("./assets/pulicy/just.png")+")"},
      nowpage:0
    };
  },
  mounted() {
    // cloab传过来 让此页面98行的 框框消失
    this.emit.$on("show", e => {
      this.control = false;
    });
    this.emit.$on("block", () => {
      // this.riskt = true;
      document.getElementById("risk1").style.display = "block";
//    document.getElementById("risk2").style.display = "block";
    });
    this.emit.$on("item", e => {
         console.log(e,"dada");
      if (e == 1 || e == 2) {
        this.price = false;
        this.dddd();
      }
      this.nowpage = e;
      // this.nubre = 100;
    });
    this.emit.$on("item4", e => {
      console.log(e, "ddsada");
      this.ifshow = true;
      switch (e) {
        case 0:
          this.ifsrc = "sence1/indexsixthpart.html";
          break;
        case 1:
          this.ifsrc = "sence2/indexfivepart.html";
          break;
        case 2:
          this.ifsrc = "sence3/indexthirdpart.html";
          break;
        case 3:
          this.ifsrc = "sence4/index1.html";
          break;
      }
    });
    //  98行 框的方法
    window.controlx = this.controlx;
    window.risktt = this.risktt;
    window.popdata = this.popdata;
    // 请求 三维设备json
    beseGet().then(e => {
      //  for (let i = 0; i < e.model.length; i++) {
      //    if (e.model[i].area !== "polymerization") {
      //      this.beselist.push(e.model[i]);
      //    } else if (e.model[i].area == "polymerization") {
      //      this.beselist1.push(e.model[i]);
      //    }
      //  }
      //  // 发送到cloab.vue
      //  setTimeout(() => {
      //    this.emit.$emit("beselist", this.beselist);
      //    this.emit.$emit("beselist1", this.beselist1);
      //  }, 1000);
      // console.log(e,"ddd");
      let jhids = [];
      e.model.forEach(item => {
        if (item.type == 26) {
          jhids.push({ id: item.id });
        }
      });
      jhids.forEach(element => {
        let arr = element.id.split("/");
        let list = [];
        arr.forEach(item => {
          list.push(item);
        });
        this.jhdata.push(list);
      });
      console.log(this.jhdata, "dddd");
    });
    viderGet().then(e => {
      // let ddd = decode64(e.data)
      // window.popdata(JSON.parse(ddd));
      // console.log(JSON.parse(e.data),"ccc");
      this.videodata = JSON.parse(e.data);
    });
    connect();
    connect2();
    connect3();
    connect4();
    connect5();
    // websocketsend('topics=d3_sensor_data');
    this.timer[1] = setInterval(() => {
      this.rish = "瓦斯爆炸";
      this.bg = {backgroundImage:"url("+require("./assets/pulicy/just.png")+")"}
      document.getElementById("iframe").contentWindow.MMAPI.rish();
      // document.getElementsByClassName('risk').style.display = 'none';
    }, 5000);
    this.timer[0] = setInterval(() => {
      this.rish = "co传感器";
      document.getElementById("iframe").contentWindow.MMAPI.rish();
    }, 10000);
    this.timer[2] = setInterval(() => {
      this.bg = {backgroundImage:"url("+require("./assets/hong.png")+")"}
      this.rish = "粉尘爆炸";
      document.getElementById("iframe").contentWindow.MMAPI.rish();
    }, 15000);
    this.timer[3] = setInterval(() => {
      this.rish = "风速传感器";
      document.getElementById("iframe").contentWindow.MMAPI.rish();
    }, 20000);
    this.timer[4] = setInterval(() => {
      this.bg = {backgroundImage:"url("+require("./assets/huang.png")+")"}
      this.rish = "温度传感器";
      document.getElementById("iframe").contentWindow.MMAPI.rish();
    }, 25000);
  },
  methods: {
     bianhuang(){
        this.bg = {backgroundImage:"url("+require("./assets/huang.png")+")"}
    },
    bianhong(){
      this.bg = {backgroundImage:"url("+require("./assets/hong.png")+")"}
    },
    playover(){
      this.timer.forEach(item=>{
        clearInterval(item)
      })
      document.getElementById("iframe").contentWindow.MMAPI.rigthnav(2)
    },
    dddd(){
      this.timer.forEach(item=>{
        clearInterval(item)
      })
    },
    closesp(val) {
      document.getElementById(val).style.display = "none";
    },
    // 190行 的挂载方法
    controlx(i) {
      this.title = i.title;
      this.control = true;
    },
    risktt(i, num) {
      console.log(i);
      // this.riskt = i;
      document.getElementById(i).style.display = "none";
      document.getElementById("iframe").contentWindow.MMAPI.alimes(i, num);
    },
    close() {
      this.ifshow = false;
    },
    popdata(val) {
      console.log(val);
      let statusdata = [];
      this.beselist = val;
      this.beselist.forEach(item => {
        statusdata = [];
        if (document.getElementById("iframe").contentWindow.MMAPI.status) {
          statusdata.push([item.d3Value]);
          switch (item.devState) {
            case "正常":
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.status(statusdata, 0, false);
              break;

            case "断线":
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.status(statusdata, 1, false);
              break;

            case "故障":
              document
                .getElementById("iframe")
                .contentWindow.MMAPI.status(statusdata, 2, false);
              break;
          }
        }
      });
      this.jhpop = [];
      this.jhdata.forEach(item => {
        let list = [];
        item.forEach(item2 => {
          this.beselist.forEach(item3 => {
            if (item3.d3Value == item2) {
              list.push(item3);
              list.id += item2 + "/";
            }
          });
        });
        // console.log(list.id);
        if (list.id) {
          list.id = list.id.substr(9, list.id.length);
          list.id = list.id.substring(0, list.id.length - 1);
        }
        this.jhpop.push(list);
      });
      console.log(this.jhpop, "设备状态");
    }
  }
};
</script>
<style lang="less" scoped>
// @import "./less/less.less";
* {
  margin: 0;
  padding: 0;
}
body,
html {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
}
.title-left {
  width: 251px;
  height: 36px;
  background: url(./assets/left.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1000;
  display: none;
  .content {
    height: 100%;
    width: 125px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.title-right {
  width: 251px;
  height: 36px;
  background: url(./assets/right.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  left: 400px;
  bottom: 0;
  z-index: 1000;
  display: none;
  .content {
    height: 100%;
    width: 125px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 125px;
  }
}

.risk {
  width: 30vw;
  height: 51.1vh;
  position: absolute;
  left: 0%;
  bottom: 0%;
  background-image: url("./assets/pulicy/just.png");
  background-repeat: no-repeat;
  z-index: 1;
  background-size: 100% 100%;
  pointer-events: none;
  .subject {
    width: 16.1vw;
    height: 50vh;
    // border: 1px solid red;
    margin: 0.4vh 0 0 13.5vw;
    .title {
      width: 15vw;
      margin: 0 auto;
      height:2.5vh;
      // background-image: url("./assets/pulicy/title.png");
      // background-repeat: no-repeat;
      // background-size: 100% 100%;

      .fles(@space:center);
      color: white;
      font-weight: bold;
      font-size: 14px;
      span {
        position: absolute;
        right: 0.6vw;
    top: 0.4vh;
        color: #e8e8e8;
        cursor: pointer;
        pointer-events: auto;
      }
    }
    .risk-n {
      margin: 1.2vh 0;
      color: white;
      font-family: "Microsoft YaHei";
      font-size: 12px;
      display: flex;
      align-items: center;
      span {
        margin: 0 0.2vw;
        color: rgb(185, 216, 255);
      }
    }
    .text {
      width: 100%;
      height: 6vh;
      display: flex;
      font-size: 12px;
      .text-now {
        width: 20%;
        color: rgb(185, 216, 255);
        // font-size: 00.8vw;
        display: flex;
        align-items: center;
        height: 2vh;
        span {
          margin: 0 0.2vw;
        }
      }
      .text-sui {
        width: 80%;
        height: 6vh;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        color: white;
        // font-size: 00.8vw;
      }
    }
    .location {
      margin: 0.5vh 0;
      display: flex;
      align-items: center;
      span {
        margin: 0 0.2vw;
        color: rgb(185, 216, 255);
        font-size: 14px;
        white-space: nowrap;
      }
    }
    .information {
      height: 14vh;
      display: flex;
      flex-wrap: wrap;
      .information-boer {
        width: 43%;
        height: 4vh;
        background-image: url("./assets/pulicy/paerd.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin: 0.2vh 0.2vw;
        display: flex;
        padding: 0 0.3vw;
        align-items: center;
        color: rgb(185, 216, 255);
        font-size: 13px;
      }
    }
    .risk-area {
      width: 15vw;
      margin: 0.5vh auto;
      height: 2.5vh;
      background: rgba(102, 210, 252, 0.141);
      .fles();
      span {
        margin: 0 0.2vw;
        font-size: 12px;
        white-space: nowrap;
        color: rgb(185, 216, 255);
      }
      .risk-depend {
        width: 8vw;
        height: 0.8vh;
        background-color: rgba(102, 210, 252, 0.259);
        div {
          width: 4vw;
          height: 100%;
          background-color: rgb(102, 210, 252);
        }
      }
    }
    .sxt {
      .sxt-title {
        display: flex;
        align-items: center; 
        span {
          color: rgb(185, 216, 255);
          font-size: 14px;
        }
      }
    }
    .sxt-video {
      width: 15.5vw;
      margin: 0 auto;
      padding: 0.2vh 0.1vw;
      height: 9vh;
      .fles(@space:space-around);
      .sxt-videow {
        width: 7.1vw;
        padding: 0.1vh 0.1vw;
        height: 8vh;
        margin: auto;
        background-color: rgba(102, 210, 252, 0.122);
        span {
          color: rgb(185, 216, 255);
          font-size: 13px;
        }
        hr {
          height: 1px;
          margin: 0.1vh 0;
          border: none;
          background-color: rgba(102, 210, 252, 0.369);
        }
        div {
          width: 100%;
          height: 5.5vh;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
.videobox {
  width: 364px;
  height: 260px;
  background-image: url("./assets/spbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  display: none;
  .videohead {
    display: flex;
    height: 34px;
    width: 336px;
    margin-left: 28px;
    justify-content: center;
    align-items: center;
    color: #707782;
    font-size: 14px;
    .videotitle {
      color: #fff;
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: bold;
    }
    .videoclose {
      cursor: pointer;
      position: relative;
      right: -111px;
    }
  }
  .myvideo {
    width: 322px;
    height: 220px;
    margin-left: 35px;
  }
}
.all {
  width: auto;
  height: auto;
  background-image: url("./assets/pulicy/justper.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // display: none;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;

  .all-item {
    border-bottom: 1px solid rgba(157, 203, 255, 0.278);
    // display: flex;
    width: auto;
    height: auto;
    // margin-left: 26px;
    // padding: 10px;
    .item1 {
      display: flex;
      width: auto;
      height: auto;
      // border-bottom: 1px solid rgba(157, 203, 255, 0.278);
      .item1-child {
        min-width: 87px;
        height: 100%;
        display: flex;
        color: #fff;
        justify-content: center;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid rgba(157, 203, 255, 0.278);
        &:nth-child(1) {
          background-color: rgba(14, 146, 219, 0.2);
          box-shadow: 0px 2px 9.7px 0.3px rgba(0, 25, 43, 0.89);
        }
      }
      &:nth-last-child(1) {
        border-bottom: none;
      }
    }
  }
}

.f3D {
  width: 15vw;
  height: 30vh;
  background-image: url("./assets/pulicy/suyle.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  .f3D-title {
    width: 85%;
    height: 3vh;
    background-image: url("./assets/pulicy/title.png");
    background-size: 100% 100%;
    margin-left: 1.8vw;
    margin-top: 1vh;
    font-size: 0.9vw;
    letter-spacing: 0.2vw;
    font-weight: 800;
    color: #fff;
    .fles(@space:center);
    span {
      position: absolute;
      right: 1.5vw;
      cursor: pointer;
    }
  }
  .f3d-suyle {
    width: 85%;
    height: 3vh;
    margin: 1vh 0 0 1.8vw;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 0.8vw;
    i {
      width: 0.3vw;
      height: 0.5vh;
      border-radius: 50%;
      background-color: rgb(255, 203, 147);
      margin-right: 0.5vw;
    }
    span {
      margin-right: 0.5vw;
      font-size: 0.8vw;
    }
  }
  .buttom {
    width: 60%;
    height: 4vh;
    background-image: url("./assets/pulicy/click.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 2vh 0 0 3.6vw;
    color: #fff;
    font-size: 0.8vw;
    .fles(@space:center);
    cursor: pointer;
  }
}

.truetiem {
  padding: 0.8vh 0.6vw;
  color: rgb(207, 227, 255);
  font-size: 0.7vw;
  background-image: url("./assets/pulicy/titletrue.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 50%;
  bottom: 20%;
  z-index: 1;
}
.truetiemtwo {
  padding: 0.8vh 0.6vw;
  width: 157px;
  color: rgb(207, 227, 255);
  font-size: 0.7vw;
  background-image: url("./assets/pulicy/titletruetwo.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 50%;
  bottom: 20%;
  z-index: 1;
  div {
    word-break: break-all;
  }
}

.icon {
  width: 0.3vw;
  height: 0.5vh;
  border-radius: 50%;
  background-color: rgb(185, 216, 255);
  margin-right: 0.2vw;
  display: inline-block;
}
.iframe2 {
  width: 100%;
  height: 100%;
  z-index: 9999;
  position: absolute;
  left: 0;
  right: 0;
}
.close {
  width: 40px;
  height: 40px;
  // background: red;
  position: absolute;
  right: 30px;
  top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 9999;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
}
.playover {
  display: flex;
  width: auto;
  font-size: 13px;
  font-family: "Microsoft YaHei";
  color: #ffffff;
  position: absolute;
  right: 9vw;
  top: 7.5vh;
  border-width: 1px;
  justify-content: center;
  align-items: center;
  border-color: rgb(57, 145, 255);
  border-style: solid;
  border-radius: 10px;
  width: 105px;
  height: 31px;
  z-index: 999;
  background-color: rgba(57, 145, 255, 0.341);
  cursor: pointer;
}
</style>